module.exports = __webpack_public_path__ + "static/1-45172f2c030bbf3c7ef4f860b2990a83.jpg";